var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1125 0.500259C9.44547 -0.166753 8.36401 -0.166753 7.69699 0.500259L6.47824 1.71902C7.26052 3.06585 7.03818 4.77077 5.93674 5.87196C4.8353 6.9734 3.13063 7.19573 1.7838 6.41346L0.565042 7.63247C-0.100945 8.29974 -0.100945 9.38043 0.565042 10.0477L12.0351 21.518L21.6082 11.996L10.1125 0.500259Z",
    fill: "#FB6910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2572 12.645L12.6844 22.1671L14.0169 23.4998C14.6839 24.1666 15.7654 24.1666 16.4324 23.4998L23.5646 16.3676C24.2304 15.7001 24.2304 14.6197 23.5646 13.9521L22.2572 12.645Z",
    fill: "#FB6910"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.02b2df37895ca1938153dfe36ea4585e.svg";
export { ForwardRef as ReactComponent };